import { useEffect, useMemo, useState } from 'react';

import { NativeModules, Platform } from 'react-native';

import useDebouncedSafeAreaInsets from './useDebouncedSafeAreaInsets';

const { StatusBarManager } = NativeModules;

function useStatusBarInset() {
    const [statusBarHeight, setStatusBarHeight] = useState(0);

    const insets = useDebouncedSafeAreaInsets();

    const topPadding = useMemo(() => {
        return Math.max(insets.top, Math.max(insets.left, insets.right));
    }, [insets]);

    useEffect(() => {
        if (!statusBarHeight && topPadding) {
            setStatusBarHeight(topPadding);
        }
    }, [topPadding, statusBarHeight]);

    useEffect(() => {
        if (Platform.OS === 'ios') {
            StatusBarManager.getHeight(({ height }: { height: number }) => {
                if (height) {
                    setStatusBarHeight(height);
                }
            });
        }
    }, []);

    return Platform.select({
        default: 0,
        ios: statusBarHeight,
    });
}

export default useStatusBarInset;
